<template>
    <div class="form-group">
        <label class="font-bold mb-md block">Fält att visa</label>

        <div class="grid justify-between">
            <div class="column w-2/5 flex flex-col">
                <label class="block mb-md text-sm">Tillgängliga fält</label>

                <draggable
                    v-model="availableFields"
                    group="fields"
                    tag="ul"
                    class="list-reset bg-neutral-lightest rounded flex-grow p-sm"
                >
                    <li
                        v-for="field in availableFields"
                        :key="field.name"
                        class="block bg-neutral-dark mb-sm rounded p-sm text-white text-xs font-bold cursor-pointer"
                        @click="selectField(field.name)"
                    >
                        {{ field.label }}
                    </li>
                </draggable>
            </div>

            <div class="column w-1/5 flex flex-col text-sm mt-2xl">
                Klicka på eller dra fälten till andra sidan.
            </div>

            <div class="column w-2/5 flex flex-col">
                <label class="block mb-md text-sm">Valda fält</label>

                <draggable
                    v-model="selectedFields"
                    group="fields"
                    tag="ul"
                    class="list-reset bg-neutral-lightest rounded flex-grow p-sm"
                >
                    <li
                        v-for="field in selectedFields"
                        :key="field.name"
                        class="draggable-list-item"
                        @click="deselectField(field.name)"
                    >
                        {{ field.label }}
                        <font-awesome-icon icon="times" />
                    </li>
                </draggable>
            </div>
        </div>

        <input
            v-for="name in selectedFieldNames"
            type="hidden"
            name="display_field_names[]"
            :value="name"
        >

        <div v-if="this.$slots.default" class="my-md">
            <slot />
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        components: {
            draggable,
        },

        props: {
            displayFieldLabels: {
                type: Object,
                required: true,
            },
            initialSelectedDisplayFieldNames: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                availableFields: Object.keys(this.displayFieldLabels)
                    .filter(name => this.initialSelectedDisplayFieldNames.indexOf(name) === -1)
                    .map(name => (
                        { 'name': name, 'label': this.displayFieldLabels[name] }
                    )),
                selectedFields: this.initialSelectedDisplayFieldNames.map(name => (
                    { 'name': name, 'label': this.displayFieldLabels[name] }
                )),
            };
        },

        computed: {
            selectedFieldNames() {
                return this.selectedFields.map(field => field.name);
            },
        },

        methods: {
            selectField(fieldName) {
                this.availableFields = this.availableFields.filter(field => field.name !== fieldName);
                this.selectedFields.push({
                    name: fieldName,
                    label: this.displayFieldLabels[fieldName],
                });
            },
            deselectField(fieldName) {
                this.selectedFields = this.selectedFields.filter(field => field.name !== fieldName);
                this.availableFields.push({
                    name: fieldName,
                    label: this.displayFieldLabels[fieldName],
                });
            },
        },
    };
</script>
